import React from "react";
import moment from "moment-timezone";

import { getRegeneronPapFormInitialValues } from "./form/initialValues";
import { SaveButton } from "../../header";
import useBaseEEConfiguration from "../../hooks/useBaseEEConfiguration";
import { SubmittedFormModal } from "../../../PatientApplications/enrollTab/submission/SubmittedFormModal";
import { applyTrimFields } from "../../utils/updateFormData";
import renderReactFromJson from "../../utils/renderReactFromJson";
import formJson from "./form/RegeneronPapFormJson.json";
import { CompleteFormButton } from "../../CompleteFormButton";
import { HEADER_SUBMIT_BUTTON_TYPES } from "../../constants";
import { fileTypes, MB } from "../../../../Uploader";
import { SignerTypes } from "../../../../../constant/ESign";
import { DATE_FORMAT } from "../../../../../utils/date";
import { APPLICATIONS } from "../../../../../constant/applications";

export const useRegeneronPapConfiguration = () => {
  const vendorName = "regeneron";
  const eePlanType = "pap";
  const rootPath = "application_form_editor.regeneron.pap"; //EE TODO: add data to src/locales/translations/en/ApplicationFormEditor.js

  const baseConfig = useBaseEEConfiguration({ vendorName, eePlanType, rootPath, formJson });

  const regeneronSpecificConfig = {
    activeFormSection: "",
    getFormInitialValues: ({ applicationForm }) => getRegeneronPapFormInitialValues({ applicationForm, formJson }),
    getFormFromJson: (form) => renderReactFromJson(form, formJson),
    getViewDetailsModal: (onCancel, visible) => <SubmittedFormModal onCancel={onCancel} visible={visible} />,
    saveButton: (props) => (
      <SaveButton
        showPdfOnSave={false}
        onSave={(form) => applyTrimFields(form)}
        id={"EE_regeneron_pap_save_form"}
        {...props}
      />
    ),
    afterSubmissionPayload: () => ({ status: APPLICATIONS.statuses.applied, appliedDate: moment() }),
    applicationFormHeaderSubmission: (props) => <CompleteFormButton id={"EE_complete_button"} {...props} />,
    headerSubmitButtonType: HEADER_SUBMIT_BUTTON_TYPES.GENERATE_PDF,
    attachmentsSectionFileTypesAccepted: fileTypes.PDF,
    attachmentsSectionMaxFileSize: 6 * MB,
    shouldShowFileSize: true,
    shouldShowPdfInSecondStep: true,
    submissionStep: {
      description: (t) => t("patientApplications.enroll.application_form_submission.eSign.description"),
      getSubmitButtonText: (t) => t("patientApplications.enroll.application_form_submission.submit_button"),
      submitModal: {
        showNotice: false,
        attachments: {
          showAllowedFileTypesNotice: true
        }
      },
      getSubmitSuccessMessage: (t) => t("patientApplications.enroll.application_form_submission.submit_success_message")
    },
    successMessage: (t, submittedDate) =>
      t("patientApplications.enroll.application_form_submission.submit_completed", {
        submitDate: moment(submittedDate).format(DATE_FORMAT)
      }),
    getSignatureWidgetSettingsBySignerType: (signerType) => {
      const signatureSettings = {
        [SignerTypes.PATIENT_OR_CAREGIVER]: {
          editable: true,
          titleTranslationKey: "patientApplications.enroll.electronic_signatures.signature_step.signers.patient",
          shouldShowCaregiverIndication: false,
          shouldUseRemoteRequestCheckboxes: true,
          shouldHideMissingInfoMessage: true,
          shouldHideLinkToMPD: true
        },
        [SignerTypes.PHYSICIAN]: {
          editable: true,
          titleTranslationKey: "patientApplications.enroll.electronic_signatures.signature_step.signers.physician",
          shouldShowCaregiverIndication: false,
          shouldUseRemoteRequestCheckboxes: false
        }
      };
      return signatureSettings[signerType];
    },
    shouldHaveSignatureAsTextLabel: true,
    isModalSubmissionEnabled: true,
    contactSupportText: (t) => t("patientApplications.enroll.enroll_result.contact_time_regeneron")
  };

  return {
    ...baseConfig,
    ...regeneronSpecificConfig
  };
};

export default useRegeneronPapConfiguration;
